import { render, staticRenderFns } from "./ModalLegal.vue?vue&type=template&id=75312725&"
import script from "./ModalLegal.vue?vue&type=script&lang=js&"
export * from "./ModalLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports